var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"57231ce3167081991a057de82131cd831e31ed16"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from "@sentry/nextjs";

Sentry.init({
    dsn: "https://1f1024066b7747c4bbcea4d926aacf44@o1288930.ingest.sentry.io/6508892",

    enabled: process.env.NODE_ENV === "production",

    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.02,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    // replaysOnErrorSampleRate: 1.0,

    // // This sets the sample rate to be 10%. You may want this to be 100% while
    // // in development and sample at a lower rate in production
    // replaysSessionSampleRate: 0.1,

    // // You can remove this option if you're not planning to use the Sentry Session Replay feature:
    // integrations: [
    //     Sentry.replayIntegration({
    //         // Additional Replay configuration goes in here, for example:
    //         maskAllText: true,
    //         blockAllMedia: true,
    //     }),
    // ],
});
